import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS = [
  { code: "fr", label: "FR" },
  { code: "ar", label: "AR" },
  { code: "en", label: "EN" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.language || "fr").slice(0, 2);

  return (
    <div className="flex items-center gap-1 text-xs text-atelier-textDim" data-testid="language-switcher">
      <Globe className="w-3.5 h-3.5 mr-1 opacity-70 text-atelier-ink" strokeWidth={1.5} />
      {LANGS.map((l, i) => (
        <button
          key={l.code}
          onClick={() => i18n.changeLanguage(l.code)}
          data-testid={`lang-${l.code}`}
          className={`label-tech text-[0.65rem] px-1.5 py-1 transition-colors ${
            current === l.code ? "text-atelier-ink" : "text-atelier-textFaint hover:text-atelier-text"
          }`}
        >
          {l.label}
          {i < LANGS.length - 1 && <span className="ml-1.5 text-atelier-textFaint/40">·</span>}
        </button>
      ))}
    </div>
  );
}
